
    /** Generated by webpack-jst-loader */
    (function() {
      window.JST || (window.JST = {});
      window.JST["app_base/components/multicomplete_react/templates/layout"] = Handlebars.template({"0":function(container,depth0,helpers,partials,data) {
    return "<div class='drop-icon'>\n  <span class='sprite-global glyph-icon'></span>\n  <span class='sprite-global glyph-down_arrow'></span>\n</div>\n";
},"1":function(container,depth0,helpers,partials,data) {
    return "<div class='drop-icon'>\n  <span class='sprite-moments glyph-icon'></span>\n  <span class='sprite-global glyph-down_arrow'></span>\n</div>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div id='member_region'></div>\n<div id='input_region'></div>\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"show_icon_global") : depth0),{"name":"if","hash":{},"fn":container.program(0, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":0},"end":{"line":8,"column":7}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"show_icon_moments") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":9,"column":0},"end":{"line":14,"column":7}}})) != null ? stack1 : "")
    + "<div id='suggestion_region'></div>\n";
},"useData":true});
    }).call(this);
  